var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-ct"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/logo_t.png")}}),(_vm.showTitle)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }